import { render, staticRenderFns } from "./DeletePopover.vue?vue&type=template&id=2b63300f&"
import script from "./DeletePopover.vue?vue&type=script&lang=ts&"
export * from "./DeletePopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports